module.exports = __webpack_public_path__ + "media/images/home_01-fe38c65ac720b1c24575b9b62f621a9d.jpg";